import {
    toTitleCase,
    toUpperCase,
    toUpperCaseFirst,
} from '../helpers/string'

export const collaborativeIndexation = {
    selection: {
        minimumSize: 20,
    },
    forms: {
        french_civil_registry: {
            fields: [
                "lastname",
                "firstname",
                "age",
                "eventType",
                "eventDate",
                "eventPlace",
                "gender",
                "profession",
                "relationship",
            ]
        },
        nominative: {
            fields: [
                "lastname",
                "firstname",
            ]
        },
        nominative_with_date: {
            fields: [
                "lastname",
                "firstname",
                "eventDate",
            ]
        },
        french_military_record: {
            fields: [
                "lastname",
                "firstname",
                "birthDate",
                "profession",
                "birthPlace",
                "birthDepartment",
                "birthCountry",
                "homePlace",
                "homeDepartment",
                "homeCountry",
                "documentType",
                "militaryId",
                "conscriptionYear",
                "militaryRecordRegistry",
            ]
        },
        population_census: {
            fields: [
                "lastname",
                "firstname",
                "birthYear",
                "age",
                "profession",
                "gender",
                "eventType",
                "eventYear",
                "eventPlace",
            ]
        },
    },
}

export const fieldsFormatter = {
    default: (value) => toUpperCaseFirst(value),
    lastname: (value) => toUpperCase(value),
    firstname: (value) => toTitleCase(value),
    eventPlace: (value) => toUpperCase(value),
    birthPlace: (value) => toUpperCase(value),
    birthDepartment: (value) => toUpperCase(value),
    birthCountry: (value) => toUpperCase(value),
    homePlace: (value) => toUpperCase(value),
    homeDepartment: (value) => toUpperCase(value),
    homeCountry: (value) => toUpperCase(value),
    militaryRecordRegistry: (value) => toUpperCase(value),
}
